import { render, staticRenderFns } from "./ServiceLook.vue?vue&type=template&id=051a4d16&scoped=true&"
import script from "./ServiceLook.vue?vue&type=script&lang=js&"
export * from "./ServiceLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a4d16",
  null
  
)

export default component.exports